var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "col text-center items-center fit q-my-lg q-px-md q-px-md-lg",
      staticStyle: { clear: "both", "line-height": "1.5em" }
    },
    [
      _c(
        "h5",
        { staticClass: "q-my-none" },
        [_c("q-icon", { attrs: { name: "fa fa-hourglass-start" } })],
        1
      ),
      _c("div", {
        directives: [
          {
            name: "dompurify-html",
            rawName: "v-dompurify-html",
            value: _vm.$t(_vm.textPath, { date: _vm.salesStart }),
            expression: "$t(textPath, {date: salesStart})"
          }
        ],
        staticClass: "q-my-none text-bold",
        staticStyle: { "line-height": "1.5em" },
        attrs: { "data-test": _vm.CypressTarget("eventInformationNotOnSale") }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }